import {
    ASSOCIATIONS_FAILURE,
    ASSOCIATIONS_REQUEST,
    ASSOCIATIONS_SUCCESS,
    ASSOCIATIONS_POST_SUCCESS
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const associationListReducer = (state = initialState, action) => {
    const {type, data = [], association} = action;
    switch (type) {
        case ASSOCIATIONS_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, association]
            }
        }

        case ASSOCIATIONS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case ASSOCIATIONS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case ASSOCIATIONS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
